import { Typography } from "@mui/material";
import React from "react";
import SectionHeader from "./SectionHeader";
import DetailCaption from "./DetailCaption";

function CampsitesAndVisitation() {
  return (
    <>
      <SectionHeader>Student Sleeping Areas</SectionHeader>
      <DetailCaption>
        There are designated boys and girls sleeping areas for students.
      </DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>
            Each student enrolled in Harmony Hill Singing School is required to
            camp in the boys’ or girls’ designated camping areas OR in a Family
            Camp supervised by their adult parent/guardian, NO EXCEPTIONS.
          </li>
          <li>
            Dressing buildings, restrooms, and sleeping areas are to be kept
            NEAT, CLEAN AND ORDERLY at all times.
          </li>
        </ul>
      </Typography>
      <SectionHeader>Family Camps</SectionHeader>
      <DetailCaption>
        A family camp is any campsite other than the sleeping areas designated
        for boys and for girls.
      </DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>
            Each family camp must be established by an adult, age 21 or older,
            for the purpose of providing a site for his/her “family” to keep
            their belongings, to rest, and to sleep at night.
          </li>
          <li>
            A family camp may be tent, pop-up, travel trailer, motor home, etc.
          </li>
          <li>
            Family camps are to be supervised by the responsible adult at all
            times.
          </li>
        </ul>
      </Typography>
      <SectionHeader>Visitation</SectionHeader>
      <DetailCaption>
        Visitation should take place in the public areas of Harmony Hill.
      </DetailCaption>
      <Typography variant="body2">
        As some of our family camps have evolved from open tent sites to closed,
        air-conditioned campers, some of our students have begun using the
        air-conditioned environment for visiting. Student visitation should take
        place in the public areas of Harmony Hill, as{" "}
        <b>
          these areas can be supervised by our personnel and the students can be
          easily located if needed.
        </b>
        <ul>
          <li>Public areas Include:</li>
          <ul>
            <li>the Judy Hilland Fellowship Area (the coke tent)</li>
            <li>the Pavilion</li>
            <li>the Recreation and Craft areas</li>
          </ul>
          <li>
            <b>
              Adults and students occasionally visit at individual campsites,
            </b>{" "}
            especially during the afternoon recreation period. Such visitation
            must be outside, not inside, family camps.
          </li>
          <li>
            <b>
              If students are visiting with students, unaccompanied by an adult,
            </b>{" "}
            that visitation should take place in one of the designated visiting
            areas noted above.
          </li>
          <li>
            <b>After evening sessions,</b> everyone is required to confine
            visiting to DESIGNATED LIGHTED AREAS.
          </li>
          <li>
            <b>All students are required to abide by our evening curfew</b> and
            “SILENCE AFTER TAPS”, and we urgently request that adults do also,
            as much as possible.
          </li>
        </ul>
      </Typography>
    </>
  );
}

export default CampsitesAndVisitation;
